var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "#fff",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.364 1.697A.75.75 0 1 0 12.303.636L7 5.939 1.696.636a.75.75 0 0 0-1.06 1.06L5.939 7 .636 12.303a.75.75 0 0 0 1.06 1.06L7 8.062l5.303 5.303a.75.75 0 0 0 1.06-1.06L8.06 7z"
  })));
};
export default SvgCross;